// ============================================================
// Reports Module — Router (index.tsx)
// Lazy-loads report sub-routes under /component/reports.
// Angular source: AdvancedDashboardReportModule (reports routes)
// ============================================================
import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const DynamicReports = lazy(() => import('./DynamicReports'));
const PpObservationReport = lazy(() => import('./PpObservationReport'));

const ReportsModule: React.FC = () => {
  return (
    <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
      <Routes>
        <Route path="dynamic_reports" element={<DynamicReports />} />
      </Routes>
    </Suspense>
  );
};

export default ReportsModule;

// Standalone route lives at /component/pp-observation-report (a sibling of
// /component/reports), so it is exported for direct registration in AppRoutes.
export const PpObservationReportPage: React.FC = () => (
  <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
    <PpObservationReport />
  </Suspense>
);
